import { Link } from 'react-router-dom'
import styles from '../../styles/module/Tour.module.scss'

const Tour = ({ data, handleJoinGroup, handleGroupDetail }) => {
    return (
        <>
            {data.map((item, i) =>
                <Link to={`./${item.id}`} key={i}>
                    <figure className={styles.tourItem}>
                        <img src={`${process.env.REACT_APP_UPLOAD}images/${item.cover}`} />
                        <figcaption>
                            {item.title}
                        </figcaption>
                    </figure>
                </Link>
            )}
        </>
    )
}

export default Tour;
